import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import useItem from '@hooks/item/useItem';
import useShop from '@hooks/shop/useShop';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useActivity } from '@stackflow/react';
import { ItemActivityIdProvider } from '@store/item/context/ItemActivityContext';
import { useTranslation } from 'react-i18next';

import ItemContents from './components/ItemContents';
import ItemDetailSkeleton from './components/skeletons/ItemDetailSkeleton';
import ItemFooterSkeleton from './components/skeletons/ItemFooterSkeleton';
import usePrepareOrder from './hooks/usePrepareOrder';

interface Params {
    itemId: string;
    shopId: string;
}

declare module '@stackflow/config' {
    interface Register {
        ItemActivity: Params;
    }
}

const ItemActivity: ActivityComponentType<'ItemActivity'> = ({ params }) => {
    const { itemId, shopId } = params;
    const { id: activityId } = useActivity();
    const item = useItem(itemId);
    const shop = useShop(shopId);
    const { t } = useTranslation('item');
    usePrepareOrder({ itemId, shopId });

    return (
        <ItemActivityIdProvider value={activityId}>
            <AppScreen>
                {(item && shop) ? (
                    <ItemContents item={item} shopId={shopId}/>
                ) : (
                    <CtaLayout header={<Header title={t('header.title')} />}
                        footer={<ItemFooterSkeleton/>} >
                        <ItemDetailSkeleton/>
                    </CtaLayout>
                )}

            </AppScreen>
        </ItemActivityIdProvider>
    );
};

export default ItemActivity;
